import { KYMW1312Model } from '../kymw1312.model';
import { KYMW1312GetSetPlanPromotionGoodsInfoModel } from '../vo/kymw1312-get-set-plan-promotion-goods-info.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * バンドルミックスマッチ画面　プロモーション商品情報を取得するサービス
 *
 * @export GetSetPlanPromotionGoodsInfoService
 * @class GetSetPlanPromotionGoodsInfoService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetSetPlanPromotionGoodsInfoService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW1312Model}
   * @memberof GetSetPlanPromotionGoodsInfoService
   */
  private model: KYMW1312Model;

  /**
   * 処理に使用するvo
   *
   * @private
   * @type {KYMW1312GetSetPlanPromotionGoodsInfoModel}
   * @memberof GetSetPlanPromotionGoodsInfoService
   */
  private vo: KYMW1312GetSetPlanPromotionGoodsInfoModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetSetPlanPromotionGoodsInfoService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        PromotionNo: this.vo.promotionNo,
        PromotionDiv: this.vo.promotionDiv,
        PromotionName: this.vo.promotionName,
        PCode: this.vo.pCode,
        SetDelivGoodsName: this.vo.setDelivGoodsName,
        CoopCode: this.vo.coopCode,
        ClassCode: this.vo.classCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetSetPlanPromotionGoodsInfoService
   */
  execute(model: any, vo: any): void {
    this.model = <KYMW1312Model>model;
    this.vo = vo;
    this.send('getSetPlanPromotionGoodsInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetSetPlanPromotionGoodsInfoService
   */
  success(data: any): void {
    this.model.KYMW1312Component.initDisplay();

    this.model.updateSetPlanPromotionInfo(data);

    this.model.KYMW1312Component.setEnabledBtn();
  }
}
